// Chakra 2 Button theme (refactored from recipe)
const Button = {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    _active: {
      boxShadow: 'none',
      outline: 'none',
    },
    _focus: {
      boxShadow: 'none',
      outline: 'none',
    },
    _focusVisible: {
      boxShadow: 'none',
      outline: 'none',
    },
  },
  variants: {
    dominus: {
      color: 'white',
      bgGradient: 'linear(to-r, #06451c, #002e0b)',
      borderRadius: 'md',
      borderWidth: '1px',
      borderColor: 'black',
      _hover: {
        bgGradient: 'linear(to-r, #116d00, #0f5a00)',
      },
      _active: {
        bgGradient: 'linear(to-r, #116d00, #06451c)',
      },
      _disabled: {
        bgGradient: 'linear(to-r, gray.400, gray.600)',
        color: 'gray.200',
        cursor: 'not-allowed',
        borderColor: 'gray.500',
      },
    },
    ghost: {
      bg: 'transparent',
      color: 'white',
      _hover: {
        bg: 'whiteAlpha.200',
      },
    },
  },
  sizes: {
    sm: { px: 4, fontSize: "12px" },
    lg: { px: 8, fontSize: "24px" },
  },
  defaultProps: {
    variant: 'dominus',
  },
};

export default Button;